module.exports = __webpack_public_path__ + "static/media/enjoy branco.4c2e7559.png";